import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api.js';

/**
 * Custom hook to access company settings across the app.
 * Provides reactive access to attendance_enabled and other settings.
 */
export function useCompanySettings() {
  const { data, ...rest } = useQuery({
    queryKey: ['companySettings'],
    queryFn: () => api.get('/settings/company'),
    staleTime: 5 * 60 * 1000,
  });

  return {
    attendanceEnabled: data?.attendance_enabled !== false,
    settings: data,
    ...rest,
  };
}